import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-zentra-admin-delete-dialog',
    templateUrl: './zentra-admin-delete-dialog.component.html',
    styleUrls: ['./zentra-admin-delete-dialog.component.scss'],
    standalone: false
})
export class ZentraAdminDeleteDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ZentraAdminDeleteDialogComponent>
  ) {}
  /* istanbul ignore next */
  cancelDelete() {
    console.log('Delete cancelled');
    this.dialogRef.close(false);
  }
  /* istanbul ignore next */
  confirmDelete() {
    console.log('Delete confirmed');
    this.dialogRef.close(true);
  }
}
